export const messages = {
  en: {
    simplifyAcceptance: {
      houseNumber: 'House Number',
      ownerName: 'Owner Name',
      ownerPhone: 'Owner Phone',
      ownerIdCard: 'Owner ID Card',
      licensePlate: 'License Plate',
      memberName: 'Member Name',
      memberPhone: 'Member Phone',
      memberIdCard: 'Member ID Card',
      shopNumber: 'Shop Number',
      contractNumber: 'Contract Number',
      search: 'Search',
      selectHouse: 'Select House',
      moreOperations: 'More Operations',
      handover: 'Handover',
      exitRoom: 'Exit Room',
      ownerId: 'Owner ID:',
      ownerNameLabel: 'Owner Name:',
      contactPhone: 'Contact Phone:',
      idCard: 'ID Card:',
      checkInDate: 'Check-in Date:',
      gender: 'Gender:',
      male: 'Male',
      female: 'Female',
      ownerRemark: 'Owner Remark:',
      houseNumberLabel: 'House Number:',
      shopNumberLabel: 'Shop Number:',
      houseArea: 'House Area:',
      houseType: 'House Type:',
      layout: 'Layout:',
      houseStatus: 'House Status:',
      indoorArea: 'Indoor Area:',
      rent: 'Rent:',
      houseRemark: 'House Remark:',
      accountBalance: 'Account Balance:',
      preDeposit: 'Pre-deposit',
      depositAmount: 'Renovation Deposit Amount:',
      refundDeposit: 'Refund Renovation Deposit',
      inputSearchCondition: 'Please enter search condition',
      selectHouseFirst: 'Please select a house first',
      houseNumberPlaceholder: 'Please enter house number like 1-1-1',
      ownerNamePlaceholder: 'Please enter owner name',
      ownerPhonePlaceholder: 'Please enter owner phone',
      ownerIdCardPlaceholder: 'Please enter owner ID card',
      licensePlatePlaceholder: 'Please enter license plate',
      memberNamePlaceholder: 'Please enter member name',
      memberPhonePlaceholder: 'Please enter member phone',
      memberIdCardPlaceholder: 'Please enter member ID card',
      shopNumberPlaceholder: 'Please enter shop number like 1-1',
      contractNumberPlaceholder: 'Please enter contract number',
      houseFee: 'House Fee',
      parkingFee: 'Parking Fee',
      paymentHistory: 'Payment History',
      house: 'House',
      contract: 'Contract',
      familyMember: 'Family Member',
      vehicle: 'Vehicle',
      paymentReminder: 'Payment Reminder',
      ownerFeedback: 'Owner Feedback',
      repairOrder: 'Repair Order',
      complaintOrder: 'Complaint Order',
      ownerSync: 'Owner Sync',
      vehicleSync: 'Vehicle Sync',
      reprintReceipt: 'Reprint Receipt',
      historyOwner: 'History Owner',
      meterReadingRecord: 'Meter Reading Record'
    },
    finishFee: {
      confirmOperation: 'Please confirm your operation',
      confirmFinishFee: 'Confirm to finish the fee? Once finished, it cannot be re-enabled. Please operate carefully!',
      cancel: 'Cancel',
      confirm: 'Confirm',
      successMessage: 'Fee finished successfully',
      errorMessage: 'Failed to finish fee'
    },
    simplifyCarFee: {
      buyMonthCard: 'Buy Monthly Card',
      batchPayment: 'Batch Payment',
      createFee: 'Create Fee',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      amountReceivable: 'Amount Receivable',
      accountingTime: 'Accounting Time',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      status: 'Status',
      operation: 'Operation',
      lastDegree: 'Last Degree',
      currentDegree: 'Current Degree',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      algorithm: 'Algorithm',
      usage: 'Usage',
      fixedFee: 'Fixed Fee',
      payment: 'Payment',
      paymentHistory: 'Payment History',
      moreOperations: 'More Operations',
      cancelFee: 'Cancel Fee',
      manualFinish: 'Manual Finish',
      feeChange: 'Fee Change',
      details: 'Details',
      note1: 'Note: "-" in receivable end time means not yet receivable or payment has ended',
      note2: 'Amount receivable -1 generally means there is an error in the fee item formula setting, please check',
      arrearsSubtotal: 'Arrears Subtotal',
      parkingLot: ' Parking Lot ',
      parkingSpace: ' Parking Space',
      owner: 'Owner',
      phone: 'Phone'
    },
    simplifyContract: {
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      parentContractCode: 'Parent Contract Code',
      contractType: 'Contract Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      operation: 'Operation',
      fee: 'Fee',
      view: 'View',
      print: 'Print',
      draftContract: 'Draft Contract'
    },
    simplifyOwnerMember: {
      addMember: 'Add Member',
      memberId: 'Member ID',
      name: 'Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      type: 'Type',
      idCard: 'ID Card',
      contact: 'Contact',
      creator: 'Creator',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    simplifyOwnerCar: {
      addCar: 'Add Vehicle',
      plateNumber: 'Plate Number',
      carBrand: 'Car Brand',
      carType: 'Car Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      operation: 'Operation',
      releaseSpace: 'Release Space',
      renewSpace: 'Renew Space',
      edit: 'Edit',
      delete: 'Delete',
      parkingLot: 'Parking Lot',
      space: 'Space',
      none: 'None'
    },
    simplifyOwnerRepair: {
      phoneRepair: 'Phone Repair',
      workOrderCode: 'Work Order Code',
      location: 'Location',
      repairType: 'Repair Type',
      reporter: 'Reporter',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      status: 'Status',
      operation: 'Operation',
      details: 'Details'
    },
    simplifyOwnerComplaint: {
      complaint: 'Complaint',
      complaintType: 'Complaint Type',
      house: 'House',
      building: 'Building',
      unit: 'Unit',
      room: 'Room',
      complainant: 'Complainant',
      complainantPhone: 'Complainant Phone',
      complaintStatus: 'Complaint Status',
      handler: 'Handler',
      handlerPhone: 'Handler Phone',
      operation: 'Operation',
      details: 'Details',
      flowChart: 'Flow Chart',
      none: 'None'
    },
    simplifyOwnerAccessContol: {
      objectType: 'Object Type',
      objectName: 'Object Name',
      command: 'Command',
      status: 'Status',
      remark: 'Remark',
      syncTime: 'Sync Time',
      operation: 'Operation',
      resync: 'Resync'
    },
    simplifyOwnerTransactionCar: {
      syncId: 'Sync ID',
      objectType: 'Object Type',
      objectName: 'Object Name',
      command: 'Command',
      status: 'Status',
      remark: 'Remark',
      syncTime: 'Sync Time',
      operation: 'Operation',
      resync: 'Resync'
    },
    simplifyShopsHireLog: {
      ownerName: 'Owner Name',
      ownerPhone: 'Owner Phone',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      operation: 'Operation',
      viewFee: 'View Fee'
    }
  },
  zh: {
    simplifyAcceptance: {
      houseNumber: '房屋号',
      ownerName: '业主姓名',
      ownerPhone: '业主电话',
      ownerIdCard: '业主身份证',
      licensePlate: '车牌号',
      memberName: '成员姓名',
      memberPhone: '成员手机号',
      memberIdCard: '成员身份证',
      shopNumber: '商铺号',
      contractNumber: '合同号',
      search: '查询',
      selectHouse: '选择房屋',
      moreOperations: '更多操作',
      handover: '交房',
      exitRoom: '退房',
      ownerId: '业主编号：',
      ownerNameLabel: '业主名称：',
      contactPhone: '联系电话：',
      idCard: '身份证：',
      checkInDate: '入住日期：',
      gender: '性别：',
      male: '男',
      female: '女',
      ownerRemark: '业主备注：',
      houseNumberLabel: '房屋编号：',
      shopNumberLabel: '商铺编号：',
      houseArea: '房屋面积：',
      houseType: '房屋类型：',
      layout: '户型：',
      houseStatus: '房屋状态：',
      indoorArea: '室内面积：',
      rent: '租金：',
      houseRemark: '房屋备注：',
      accountBalance: '账户余额：',
      preDeposit: '预存',
      depositAmount: '装修保证金金额：',
      refundDeposit: '退装修保证金',
      inputSearchCondition: '请输入查询条件',
      selectHouseFirst: '请先选择房屋',
      houseNumberPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1',
      ownerNamePlaceholder: '请输入业主名称',
      ownerPhonePlaceholder: '请输入业主手机号',
      ownerIdCardPlaceholder: '请输入业主身份证',
      licensePlatePlaceholder: '请输入业主车牌号',
      memberNamePlaceholder: '请输入家庭成员名称',
      memberPhonePlaceholder: '请输入家庭成员电话',
      memberIdCardPlaceholder: '请输入家庭成员身份证',
      shopNumberPlaceholder: '请输入商铺编号 楼栋-商铺 如1-1',
      contractNumberPlaceholder: '请输入合同号',
      houseFee: '房屋费用',
      parkingFee: '停车费用',
      paymentHistory: '缴费历史',
      house: '房屋',
      contract: '合同',
      familyMember: '家庭成员',
      vehicle: '车辆',
      paymentReminder: '催缴',
      ownerFeedback: '业主反馈',
      repairOrder: '报修单',
      complaintOrder: '投诉单',
      ownerSync: '业主同步',
      vehicleSync: '车辆同步',
      reprintReceipt: '补打收据',
      historyOwner: '历史业主',
      meterReadingRecord: '抄表记录'
    },
    finishFee: {
      confirmOperation: '请确认您的操作',
      confirmFinishFee: '确定结束费用？结束后无法重新启用，请谨慎操作！',
      cancel: '点错了',
      confirm: '结束费用',
      successMessage: '结束费用成功',
      errorMessage: '结束费用失败'
    },
    simplifyCarFee: {
      buyMonthCard: '买月卡',
      batchPayment: '批量缴费',
      createFee: '创建费用',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      amountReceivable: '应收金额',
      accountingTime: '建账时间',
      receivablePeriod: '应收时间段',
      description: '说明',
      status: '状态',
      operation: '操作',
      lastDegree: '上期度数',
      currentDegree: '本期度数',
      unitPrice: '单价',
      additionalFee: '附加费',
      algorithm: '算法',
      usage: '用量',
      fixedFee: '固定费',
      payment: '缴费',
      paymentHistory: '缴费历史',
      moreOperations: '更多操作',
      cancelFee: '取消费用',
      manualFinish: '手工结束',
      feeChange: '费用变更',
      details: '详情',
      note1: '注意： 应收结束时间 "-" 表示未到应收时间 或 收费已结束',
      note2: '应收金额 为-1 一般为费用项公式设置出错请检查',
      arrearsSubtotal: '欠费小计',
      parkingLot: '车场',
      parkingSpace: '车位',
      owner: '业主',
      phone: '电话'
    },
    simplifyContract: {
      contractName: '合同名称',
      contractCode: '合同编号',
      parentContractCode: '父合同编号',
      contractType: '合同类型',
      startTime: '开始时间',
      endTime: '结束时间',
      status: '状态',
      operation: '操作',
      fee: '费用',
      view: '查看',
      print: '打印',
      draftContract: '起草合同'
    },
    simplifyOwnerMember: {
      addMember: '添加成员',
      memberId: '成员ID',
      name: '名称',
      gender: '性别',
      male: '男',
      female: '女',
      type: '类型',
      idCard: '身份证',
      contact: '联系方式',
      creator: '创建员工',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    simplifyOwnerCar: {
      addCar: '添加车辆',
      plateNumber: '车牌号',
      carBrand: '车辆品牌',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      startTime: '起租时间',
      endTime: '截止时间',
      status: '状态',
      operation: '操作',
      releaseSpace: '释放车位',
      renewSpace: '续租车位',
      edit: '修改',
      delete: '删除',
      parkingLot: '车场',
      space: '车位',
      none: '无'
    },
    simplifyOwnerRepair: {
      phoneRepair: '电话报修',
      workOrderCode: '工单编码',
      location: '位置',
      repairType: '报修类型',
      reporter: '报修人',
      contact: '联系方式',
      appointmentTime: '预约时间',
      status: '状态',
      operation: '操作',
      details: '详情'
    },
    simplifyOwnerComplaint: {
      complaint: '投诉',
      complaintType: '投诉类型',
      house: '房屋',
      building: '号楼',
      unit: '单元',
      room: '室',
      complainant: '投诉人',
      complainantPhone: '投诉人电话',
      complaintStatus: '投诉状态',
      handler: '处理人',
      handlerPhone: '处理电话',
      operation: '操作',
      details: '详情',
      flowChart: '流程图',
      none: '无'
    },
    simplifyOwnerAccessContol: {
      objectType: '对象类型',
      objectName: '对象名称',
      command: '指令',
      status: '状态',
      remark: '说明',
      syncTime: '同步时间',
      operation: '操作',
      resync: '重新同步'
    },
    simplifyOwnerTransactionCar: {
      syncId: '同步ID',
      objectType: '对象类型',
      objectName: '对象名称',
      command: '指令',
      status: '状态',
      remark: '说明',
      syncTime: '同步时间',
      operation: '操作',
      resync: '重新同步'
    },
    simplifyShopsHireLog: {
      ownerName: '业主名称',
      ownerPhone: '业主电话',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '创建时间',
      operation: '操作',
      viewFee: '查看费用'
    }
  }
}